import { useState } from "react"
import FormDocuSign from "../form/FormDocuSign"
import BulkClientDocument from "../crm/fileDetails/BulkClientDocument"
import { Layout, Menu } from 'antd'

import {
    FormOutlined,
    CopyOutlined
  } from '@ant-design/icons'

import "./BulkRequest.css"


const BulkRequest = () => {
    const { Sider } = Layout
    const [selectedKey, setSelectedKey] = useState("1")

    const getItem = (label, key, icon, children) => {
        return {
          key,
          icon,
          children,
          label,
        }
    }

    const items = [
        getItem('Bulk Docusign Request', '1', <FormOutlined />),
        getItem('Bulk Document Upload', '2', <CopyOutlined />)
    ]

    return(
        <Layout style={{minHeight: '100vh'}}>
            <Sider
                width={280}
                theme="light"
                breakpoint="lg"
                collapsedWidth="0"
                onBreakpoint={(broken) => {
                console.log(broken);
                }}
                onCollapse={(collapsed, type) => {
                console.log(collapsed, type);
                }}
                onChange={(e) => console.log(e)}
                style={{borderRight: '1px solid lightgray'}}
            >
                <div className="demo-logo-vertical" style={{padding: '20px',}}/>
                <Menu theme="light" mode="inline" defaultSelectedKeys={[selectedKey]} items={items} onClick={(e) => setSelectedKey(e.key)} />
            </Sider>
            <div className="bulk-main">
                <div className="bulk-container">
                    {selectedKey === "1" && <FormDocuSign isBulk={true} />}
                    {selectedKey === "2" && <BulkClientDocument />}
                </div>
            </div>
        </Layout>
    )
}

export default BulkRequest